export type TableAmountFilterOp = 'eq' | 'gt' | 'gte' | 'lt' | 'lte'

export const TABLE_AMOUNT_FILTER_OPS: { value: TableAmountFilterOp; label: string }[] = [
  { value: 'eq', label: '=' },
  { value: 'gt', label: '>' },
  { value: 'gte', label: '≥' },
  { value: 'lt', label: '<' },
  { value: 'lte', label: '≤' },
]

export function parseAmountFilter(
  amount: string,
  amountOp: TableAmountFilterOp
): { amount?: number; op: TableAmountFilterOp } {
  const raw = amount.trim()
  if (!raw) return { op: amountOp }
  const parsed = parseFloat(raw.replace(/,/g, '').replace(/\$/g, ''))
  if (!Number.isFinite(parsed)) return { op: amountOp }
  return { amount: parsed, op: amountOp }
}

export function matchesNumericFilter(
  value: number | null,
  amount: string,
  amountOp: TableAmountFilterOp
): boolean {
  const { amount: target, op } = parseAmountFilter(amount, amountOp)
  if (target === undefined) return true
  if (value == null || !Number.isFinite(value)) return false
  if (op === 'eq') return Math.round(value * 100) === Math.round(target * 100)
  if (op === 'gt') return value > target
  if (op === 'gte') return value >= target
  if (op === 'lt') return value < target
  if (op === 'lte') return value <= target
  return true
}

export function containsText(haystack: string, needle: string): boolean {
  const term = needle.trim().toLowerCase()
  if (!term) return true
  return haystack.toLowerCase().includes(term)
}

export function hasActiveAmountFilter(
  amount: string,
  amountOp: TableAmountFilterOp
): boolean {
  return parseAmountFilter(amount, amountOp).amount !== undefined
}
